// extracted by mini-css-extract-plugin
export default {"redditIcon":"reddit-icon_redditIcon__QlD7g"};